import { TypeProductDetail } from "@/lib/redux/features/product/type";

export const getProductName = (product: TypeProductDetail) => {
  const productTitle = product?.title
  const productName = product?.name
  const product_details = product?.product_details

  return productTitle || productName || product_details?.name || ""
}